import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentTaskActivity } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1100. 支払タスクアクティビティ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_activities
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const paymentTaskActivities = (props: Props): Promise<PaymentTaskActivity[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.id}/payment_task_activities`
  );
};

export const usePaymentTaskActivities = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => paymentTaskActivities(props),
  });
};

export const usePaymentTaskActivitiesInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'payment_tasks',
    props.id,
    'payment_task_activities',
  ];
};
